<!-- 梅州柚子-->
<template>
 <div class='container' :style='style'>
   <div class='top'>
        <div class='weather-section'>
          <chart-box>
             <wheather></wheather>
          </chart-box>
         </div>
        <img class='title-img' src='//img.yimutian.com/crm/5dd758fb2d211f714f29661c3cca08fc.png'/>
        <div class='logo-section' @click="goHome"></div>
   </div>
   <div class='bottom'>
      <div class='left-section'>
            <div class='left-top'>
              <div class='rank-provider'>
                  <div class='block-title title-back-one'>
                     <span class='block-big-title'>最受欢迎的供应商</span>
                  </div>
                  <div class='block-sub-title'>
                    广东柚子供应商在一亩田平台被采购商浏览次数最多的前30位
                  </div>
                  <div class='rank-provider-container'>
                        <chart-box>
                           <pop-provider></pop-provider>
                       </chart-box>
                  </div>
              </div>

               <div class='capture-rate'>
                  <div  class='block-title title-back-one'>
                     <span class='block-big-title'>采购渗透率</span>
                  </div>
                  <div class='block-sub-title'>
                     全国柚子地级行政区渗透率+全国柚子采购商渗透率
                  </div>
                  <div class='rate-container'>
                       <!--采购渗透率-->
                        <chart-box>
                          <div class='top-ration'>
                            <div class='ration-city'>
                                <buyerRationCity></buyerRationCity>
                            </div>
                            <div class='ration-person'>
                                <buyerRationPerson></buyerRationPerson>
                            </div>
                           </div>
                           <div class='bottom-ration'>
                              <div class='ration-words'>
                                 地级行政区渗透率：广东柚子在全国地级行政区的渗透率<br/>
                                 采购商渗透率：广东柚子在全国柚子采购商中的渗透率
                              </div>
                           </div>
                       </chart-box>
                  </div>
              </div>
            </div>

            <div class='left-middle'>
                  <div class='block-title single-line-title title-back-two'>
                     <span class='block-big-title'>供应热度</span>
                     <span class='block-big-sub-title'>·广东用户在一亩田平台发布&amp;编辑广东柚子供应信息的次数</span>
                  </div>
                  <div class='hot-degree'>
                     <!--供应热度-->
                       <chart-box>
                           <provideHot></provideHot>
                       </chart-box>
                  </div>
            </div>
            <div class='left-bottom'>
                 <div class='block-title single-line-title title-back-three'>
                     <span class='block-big-title'>采购商指数</span>
                     <span class='block-big-sub-title'>·由一亩田平台上关注广东柚子的采购商的搜索、查看、联系下单等行为数据构成，旨在反应广东柚子的采购热度</span>
                  </div>
                  <div class='hot-degree'>
                      <!--采购商指数-->
                       <chart-box>
                          <buyerData></buyerData>
                       </chart-box>
                  </div>
            </div>
      </div>
      <div class='middle-section'>
            <div class='middle-title'>
                  <div class='block-title title-back-one'>
                     <span class='block-big-title'>销售流向</span>
                  </div>
                  <div class='block-sub-title'>
                       各城市采购商对广东柚子的实时关注度
                  </div>
            </div>
            <div class='middle-map'>
               <!--中国地图-->
               <chart-box>
                   <chinaMap ></chinaMap>
               </chart-box>
            </div>
      </div>
      <div class='right-section'>
            <div class='right-top'>
                  <div class='block-title  title-back-four'>
                     <span class='block-big-title'>平台综合价格</span>
                  </div>
                  <div class='block-sub-title'>
                        一亩田平台的柚子综合价格
                  </div>
                  <div class='place-price'>
                     <!--产地价格-->
                       <chart-box>
                         <originPrice></originPrice>
                       </chart-box>
                  </div>
            </div>
            <div class='right-middle'>
                  <div class='block-title single-line-title title-back-five'>
                     <span class='block-big-title'>批发市场综合价格</span>
                     <span class='block-big-sub-title'>全国批发市场的柚子综合价格</span>
                  </div>
                  <div class='market-price'>
                     <!--市场价格+规格-->
                       <chart-box>
                          <marketPrice></marketPrice>
                       </chart-box>
                  </div>
            </div>
            <div class='right-bottom'>
                  <div class='block-title single-line-title title-back-six'>
                     <span class='block-big-title'>热门采购城市</span>
                     <span class='block-big-sub-title'>·2019年最关注广东柚子的城市前30位以及2018年同期该城市对广东柚子的关注度</span>
                  </div>
                  <div class='hot-city'>
                     <!--热门采购城市-->
                       <chart-box>
                           <hotCity></hotCity>
                       </chart-box>
                  </div>
            </div>
       </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex'
import wheather from '@/components/mzyz/wheather.vue' // 天气组件
import popProvider from '@/components/mzyz/popular-provider.vue'
import chinaMap from '@/components/mzyz/china.vue'
import buyerRationCity from '@/components/mzyz/buyer-ration-city.vue'// 采购渗透率
import buyerRationPerson from '@/components/mzyz/buyer-ration-person.vue'// 采购渗透率
import provideHot from '@/components/mzyz/provideHot.vue'// 供应热度
import buyerData from '@/components/mzyz/buyer-data.vue'// 供应商指数
import originPrice from '@/components/mzyz/product-origin-price.vue'// 产地价格
import marketPrice from '@/components/mzyz/product-market-price.vue'// 市场价格
import hotCity from '@/components/mzyz/hot-city.vue'// 市场价格
import chartBox from '@/components/mzyz/chartBox.vue' // 图表外框

export default {
  data () {
    return {
      style: {}
    }
  },
  computed: {
    ...mapState({
      isVIP: state => state.user.isVIP
    })
  },
  methods: {
    // 页面适配
    setPageScale () {
      let winW = parseInt(document.body.clientWidth)
      let winH = parseInt(document.body.clientHeight)
      let ratioW = winW / 4088
      let ratioH = winH / 1730
      this.style = {
        transformOrigin: 'left top',
        transform: `scale(${ratioW},${ratioH})`
      }
    },
    goHome () {
      if (!this.isVIP) return
      this.$router.replace({
        name: 'home',
        query: {
          province_id: 20
        }
      })
    }
  },
  components: {
    chinaMap,
    chartBox,
    provideHot,
    buyerData,
    buyerRationCity,
    buyerRationPerson,
    originPrice,
    marketPrice,
    hotCity,
    popProvider,
    wheather
  },
  mounted () {
    this.setPageScale()
  }
}
</script>
<style scoped>
.ration-words{
   text-align:left;
   color:#0efcff;
}
.top-ration{
   width:100%;
   height:344px;
}
.bottom-ration{
   width:100%;
   height:80px;
   line-height:25px;
   font-size:20px;
   color:#4c6397;
   padding-left:45px;
}
.ration-city,.ration-person{
   position:relative;
   float:left;
   width:50%;
   height:344px;
}

.title-back-one{
   background:url(http://img.yimutian.com/crm/5d9169212d211f714f03890bd0c868bb.png) left center no-repeat;
   background-size:contain;
}
.title-back-two{
    background:url(http://img.yimutian.com/crm/5d916a032d211f714f038998aad145b8.png) left center no-repeat;
    background-size:contain;
}
.title-back-three{
    background:url(http://img.yimutian.com/crm/5d916a572d211f714f0389dff30e2cf0.png) left center no-repeat;
    background-size:contain;
}
.title-back-four{
    background:url(http://img.yimutian.com/crm/5d916a702d211f714f0389fa35b388d9.png) left center no-repeat;
    background-size:contain;
}
/*市场价格规格*/
.title-back-five{
    background:url(http://img.yimutian.com/crm/5d916a932d211f714f038a04481a6392.png) left center no-repeat;
    background-size:contain;
}
.title-back-six{
    background:url(http://img.yimutian.com/crm/5d916ade2d211f714f038a1cd97844a7.png) left center no-repeat;
    background-size:contain;
}

.top{
   text-align:center;
}
.title-img{
   display:inline-block;
   margin-top:46px;
   height:60px;
   width:auto;
}
.title-section{
   text-align:center;
   position:absolute;
   height:100%;
   left:772px;
   right:175px;
   background:url(http://img.yimutian.com/crm/5d916755b827736e3b0387c8a34a6139.png) center center no-repeat;
   background-size:auto 100%;
}
.weather-section{
   position:absolute;
   left:36px;
   top:46px;
   width:850px;
   height:60px;
}
.logo-section{
   position:absolute;
   right:26px;
   top:46px;
   width:150px;
   height:61px;
  background:url(http://img.yimutian.com/crm/5d916475b827736e3b0385c31babb7cc.png) center center no-repeat;
  background-size:contain;
  cursor: pointer;
}
.single-line-title{
  margin-bottom:24px;
}
.right-top{
  height:539px;
  width:100%;
  margin-bottom:22px;

}

.right-middle{
   height:462px;
   width:100%;
   margin-bottom:22px;
}
.middle-map{
  width:100%;
  height:1380px;
  position:relative;
}
.place-price{
   height:410px;
}
.hot-city{
   height:370px;
   position:relative;
}
.hot-degree{
   height:365px;
   position:relative;
}
.market-price{
    height:370px;
}
.left-bottom{
  height:455px;
  width:100%;
}
.left-middle{
   width:100%;
   height:445px;
   margin-bottom:22px;
}
.capture-rate{
   margin-left:30px;
}
.rank-provider-container,.rate-container{
  width:100%;
  height:431px;
}

.rank-provider{
   width:670px;
   height:556px;
   float:left;
}
.capture-rate{
   width:600px;
   height:581px;
   padding-bottom:25px;
   float:left;
}
.block-title{
   height:67px;
   line-height:67px;
   width:100%;
   padding-left:30px;
}
.block-sub-title{
   height:60px;
   line-height:60px;
   width:100%;
   font-size:20px;
   color:#0efcff;
}
.block-big-title{
   font-size:30px;
   color:#0dffff;
}
.block-big-sub-title{
   font-size:20px;
   color:#0dffff;
}

.left-top{
  width:100%;
  box-sizing:border-box;
  height:559px;
  margin-bottom:25px;
}
html,body{
  width:100%;
  height:100%
}
.container{
  width:4088px;
  height:1730px;
  background: url(http://img.yimutian.com/crm/5d9171f22d211f714f038edf4f7a4e65.jpeg) left top no-repeat;
  background-size:cover;
}
.top{
  position:relative;
  width:100%;
  height:186px;
  background:url(http://img.yimutian.com/crm/5d91723db827736e3b039009cfde3ee6.png) center center no-repeat;
  background-size:contain;
}

.bottom{
  width:100%;
  height:1545px;
}
.bottom>div{
  float:left;
  height:1509px;
  margin-left:28px;
  over-flow:hidden;
}
.left-section{
  width:1300px;
}
.middle-section{
  width:1376px;
}
.right-section{
  width:1300px;
}
</style>
